import { disableLooping } from './disableLooping';
import { dispose } from './dispose';
import { mapEvents } from './mapEvents';
import { startAtOffset } from './startAtOffset';
import { startAtTime } from './startAtTime';
import { stop } from './stop';

export const part = {
  disableLooping,
  dispose,
  mapEvents,
  startAtOffset,
  startAtTime,
  stop,
};
